const ANDROID_PACKAGE = "com.kodenauts.raive";
const APP_HOST = "raive.life";

function shouldSkipAppOpen() {
  const params = new URLSearchParams(window.location.search);
  return params.get("web") === "1";
}

function isAndroidDevice() {
  return /Android/i.test(navigator.userAgent || "");
}

function buildIntentUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const fallbackUrl = window.location.href.split("#")[0];
  return (
    `intent://${APP_HOST}${normalizedPath}#Intent;` +
    `action=android.intent.action.VIEW;` +
    `category=android.intent.category.BROWSABLE;` +
    `scheme=https;` +
    `package=${ANDROID_PACKAGE};` +
    `S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};` +
    `end`
  );
}

export function tryOpenAndroidApp(path = "/dashboard") {
  if (!isAndroidDevice() || shouldSkipAppOpen()) {
    return;
  }

  if (window.__raiveAppOpenAttempted) {
    return;
  }
  window.__raiveAppOpenAttempted = true;

  window.location.href = buildIntentUrl(path);
}

export function tryOpenAndroidAppForCurrentPath() {
  const path = window.location.pathname || "/";
  if (path === "/dashboard" || path.startsWith("/dashboard/")) {
    tryOpenAndroidApp("/dashboard");
  }
}
